<template>
    <div class="grid p-fluid animate__animated animate__fadeIn">
        <div class="col-12 md:col-12">
            <div class="card card-w-title">
                <HeaderBar :createButton="!!homePlacesGalleryManagement.title" @new-event="addItem = true"
                    title="مدیریت مکان صفحه اصلی" />


                <div class="grid mt-5">
                    <div class="col-12 md:col-3">
                        <h6>عنوان</h6>
                        <InputText v-model="title" dir="rtl" />
                    </div>

                    <div class="col-12 md:col-3">
                        <h6>حالت نمایش</h6>
                        <Dropdown v-model="mode" :options="modeSelection" optionLabel="type" optionValue="value" />
                    </div>


                    <div class="col-12 md:col-3 mt-1">
                        <Button @click="postHomePlacesGalleryManagement" :disabled="!title" type="button" class="mt-5"
                            label="ذخیره " />
                    </div>
                </div>


                <div v-if="!loading">
                    <div v-if="homePlacesGalleryManagement.items.length">
                        <DataTable ref="dt" :value="homePlacesGalleryManagement.items" dataKey="id"
                            class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn"
                            responsiveLayout="scroll">
                            <Column field="placeName" header="نام مکان" headerStyle="width:14%; min-width:10rem;">
                                <template #body="slotProps">
                                    {{ slotProps.data.placeName }}
                                </template>
                            </Column>
                            <Column field="title" header="عنوان" headerStyle="width:14%; min-width:10rem;">
                                <template #body="slotProps">
                                    {{ slotProps.data.title }}
                                </template>
                            </Column>
                            <Column field="description" header="توضیحات" headerStyle="width:14%; min-width:10rem;">
                                <template #body="slotProps">
                                    {{ slotProps.data.description }}
                                </template>
                            </Column>
                            <Column header="عملیات">
                                <template #body="slotProps">
                                    <Button icon="pi pi-pencil" v-tooltip.top="'ویرایش'"
                                        class="p-button-rounded p-button-secondary ml-2"
                                        @click="editPlace(slotProps.data)" />
                                    <Button icon="pi pi-trash" v-tooltip.top="'حذف'"
                                        class="p-button-rounded p-button-warning mt-2"
                                        @click="confirmDeletePlace(slotProps.data)" />
                                </template>
                            </Column>
                            <Column header="جابجایی">
                                <template #body="slotProps">
                                    <Button @click="swapOrderPlace(slotProps.data)" icon="pi pi-external-link"
                                        class="p-button-rounded p-button-secondary"
                                        :class="{ 'p-button-success': swapOrderPlaceData.FirstPlaceId == slotProps.data.placeId }, { 'p-button-success': swapOrderPlaceData.SecondPlaceId == slotProps.data.placeId }" />
                                </template>
                            </Column>

                        </DataTable>
                    </div>
                    <div v-if="!homePlacesGalleryManagement.items.length" class="text-center mt-5">
                        <h5> موردی وجود ندارد</h5>
                    </div>
                </div>


            </div>
        </div>

        <!----------------------------- modal ----------------------------->
        <Dialog v-model:visible="addItem" :style="{ width: '600px' }" header="ایجاد مکان" :modal="true" class="p-fluid">
            <div>
                <InputText v-model="placeData.title" dir="rtl" placeholder="عنوان" class="mb-5 mt-3" />
                <Textarea v-model="placeData.description" rows="1" cols="30" dir="rtl" placeholder="توضیحات" class="mb-5" />
                <Dropdown v-model="placeData.placeId" :options="allWithBriefInfo" optionLabel="name" optionValue="id"
                    placeholder="انتخاب مکان" />
                <div class="flex justify-content-center my-5">
                    <div v-if="!placeData.image">
                        <label for="fileUploaderLogo" class="w-full justify-content-center cursor-pointer">
                            <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
                        </label>
                        <input id="fileUploaderLogo" @change="onUpload($event)" accept="image/png, image/jpeg" type="file"
                            hidden />
                    </div>
                    <div v-else class="relative">
                        <img role="presentation" :src="imageConvertBlob(placeData.image)"
                            class="w-20rem h-10rem border-1 border-round-3xl" />
                        <div class="field remove-picture">
                            <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3"
                                @click="placeData.image = null" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="addItem = false" />
                <Button :disabled="loadingUpdate" type="submit" class="p-button-text" label="ایجاد" icon="pi pi-check"
                    @click="postHomePlacesGalleryManagementItem" />
            </template>
        </Dialog>
        <!----------------------------- editPlace modal ----------------------------->
        <Dialog v-model:visible="editPlaceModal" :style="{ width: '600px' }" header="ویرایش مکان" :modal="true"
            class="p-fluid">
            <div>
                <InputText v-model="editPlaceModalData.title" dir="rtl" placeholder="عنوان" class="mb-5 mt-3" />
                <Textarea v-model="editPlaceModalData.description" rows="1" cols="30" dir="rtl" placeholder="توضیحات"
                    class="mb-5" />
                <Dropdown v-model="editPlaceModalData.placeId" :options="allWithBriefInfo" optionLabel="name"
                    optionValue="id" placeholder="انتخاب مکان" />
                <div v-if="!editPlaceModalDataImage" class="flex justify-content-center my-5">
                    <div v-if="!editPlaceModalData.image">
                        <label for="fileUploaderLogo" class="w-full justify-content-center cursor-pointer">
                            <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
                        </label>
                        <input id="fileUploaderLogo" @change="onUploadEdit($event)" accept="image/png, image/jpeg"
                            type="file" hidden />
                    </div>
                    <div v-else class="relative">
                        <img role="presentation" :src="imageConvertBlob(editPlaceModalData.image)"
                            class="w-20rem h-10rem border-1 border-round-3xl" />
                        <div class="field remove-picture">
                            <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3"
                                @click="editPlaceModalData.image = null" />
                        </div>
                    </div>
                </div>
                <div v-else class="flex justify-content-center p-fluid gap-3 mb-3 align-items-center mt-5">
                    <div class="relative">
                        <img role="presentation" :src="'http://77.238.108.125:5001/' + editPlaceModalData.image" alt="Image"
                            class="w-20rem h-10rem border-1 border-round-3xl" />
                        <div class="field remove-picture">
                            <i class="pi pi-times p-3 pi-circle border-round-3xl bg-white shadow-3"
                                @click="editPlaceModalData.image = null, editPlaceModalDataImage = null" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="editPlaceModal = false" />
                <Button :disabled="loadingUpdate" type="submit" class="p-button-text" label="ویرایش" icon="pi pi-check"
                    @click="editHomePlacesGalleryManagementItem" />
            </template>
        </Dialog>
        <!----------------------------- deletePlaceDialog ----------------------------->
        <Dialog v-model:visible="deletePlaceDialog" :style="{ width: '450px' }" header="حذف" :modal="true">
            <div class="flex flex-column align-items-center justify-content-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 4rem" />
                <span class="mt-3">آیا مطمئن هستید؟</span>
            </div>
            <template #footer>
                <div class="text-center">
                    <Button label="خیر" icon="pi pi-times" class="p-button-text" @click="deletePlaceDialog = false" />
                    <Button label="بلی" icon="pi pi-check" class="p-button-text" @click="removePlace" />
                </div>
            </template>
        </Dialog>
    </div>
</template>
  
<script>
export default {
    name: "placeList",
    data() {
        return {
            loading: true,
            loadingUpdate: false,
            addItem: false,
            deletePlaceDialog: false,
            editPlaceModal: false,
            editPlaceModalData: null,
            title: null,
            editPlaceModalDataImage: null,
            mode: 0,
            modeSelection: [
                { type: "کاشی", value: 0 },
                { type: "اسلایدر", value: 1 },
            ],
            homePlacesGalleryManagement: {
                title: null
            },
            allWithBriefInfo: [],
            placeData: {
                placeId: null,
                image: null,
                title: null,
                description: null
            },
            placeId: null,
            swapOrderPlaceData: {
                FirstPlaceId: null,
                SecondPlaceId: null
            },
        };
    },
    methods: {
        async getHomePlacesGalleryManagement() {
            this.loading = true;
            await this.axios.get(`HomePlacesGalleryManagement`).then((data) => {
                this.homePlacesGalleryManagement = data.data
                this.title = this.homePlacesGalleryManagement.title
                this.mode = this.homePlacesGalleryManagement.mode
                this.loading = false;
            })
        },
        async getAllWithBriefInfo() {
            await this.axios.get(`Place/GetAllWithBriefInfo`).then((data) => {
                this.allWithBriefInfo = data.data.data
            })
        },
        async postHomePlacesGalleryManagement() {
            let data = {
                title: this.title,
                mode: this.mode
            }
            await this.axios.post('HomePlacesGalleryManagement/AddOrUpdate', data).then(() => {
                this.getHomePlacesGalleryManagement()
                this.showToast(200);
            })
        },
        async postHomePlacesGalleryManagementItem() {
            this.loadingUpdate = true
            let formData = new FormData();
            formData.append("Description", this.placeData.description);
            formData.append("Title", this.placeData.title);
            formData.append("Image", this.placeData.image);
            formData.append("PlaceId", this.placeData.placeId);
            await this.axios.post('HomePlacesGalleryManagement/items/add', formData).then(() => {
                this.addItem = false
                this.loadingUpdate = false
                this.placeData.description = null
                this.placeData.title = null
                this.placeData.image = null
                this.placeData.placeId = null
                this.getHomePlacesGalleryManagement();
                this.showToast(200);
            })
        },
        async editHomePlacesGalleryManagementItem() {
            this.loadingUpdate = true
            let formData = new FormData();
            formData.append("Description", this.editPlaceModalData.description);
            formData.append("Title", this.editPlaceModalData.title);
            formData.append("NewImage", this.editPlaceModalData.image);
            formData.append("PlaceId", this.editPlaceModalData.placeId);
            await this.axios.put('HomePlacesGalleryManagement/items/update', formData).then(() => {
                this.loadingUpdate = false
                this.editPlaceModal = false
                this.editPlaceModalData.description = null
                this.editPlaceModalData.title = null
                this.editPlaceModalData.image = null
                this.editPlaceModalData.placeId = null
                this.getHomePlacesGalleryManagement();
                this.showToast(200);
            })
        },
        editPlace(data) {
            this.editPlaceModalData = data
            this.editPlaceModalDataImage = data.image
            this.editPlaceModal = true
        },
        confirmDeletePlace(data) {
            this.placeId = data.placeId
            this.deletePlaceDialog = true
        },
        async removePlace() {
            let data = {
                placeId: this.placeId
            }
            await this.axios.delete('HomePlacesGalleryManagement/items/remove', { data: data }).then(() => {
                this.deletePlaceDialog = false
                this.getHomePlacesGalleryManagement();
                this.showToast(200);
            })
        },
        swapOrderPlace(data) {
            if (this.swapOrderPlaceData.FirstPlaceId) {
                if (this.swapOrderPlaceData.FirstPlaceId != data.placeId) {
                    this.swapOrderPlaceData.SecondPlaceId = data.placeId
                    this.postSwapOrderPlace();
                }
                else {
                    this.swapOrderPlaceData.FirstPlaceId = null
                    this.swapOrderPlaceData.SecondPlaceId = null
                }
            }
            else {
                this.swapOrderPlaceData.FirstPlaceId = data.placeId
            }
        },
        async postSwapOrderPlace() {
            let data = {
                FirstPlaceId: this.swapOrderPlaceData.FirstPlaceId,
                SecondPlaceId: this.swapOrderPlaceData.SecondPlaceId
            }
            await this.axios.post('HomePlacesGalleryManagement/items/swapOrder', data).then(() => {
                this.swapOrderPlaceData.FirstPlaceId = null
                this.swapOrderPlaceData.SecondPlaceId = null
                this.getHomePlacesGalleryManagement();
                this.showToast(200);
            })
        },
        imageConvertBlob(picture) {
            return URL.createObjectURL(picture);
        },
        onUpload(event) {
            this.placeData.image = event.target.files[0]
        },
        onUploadEdit(event) {
            this.editPlaceModalData.image = event.target.files[0]
        },
    },
    mounted() {
        this.getHomePlacesGalleryManagement();
        this.getAllWithBriefInfo();
    },
};
</script>
  
<style lang="scss" scoped>
.file-uploader {
    width: auto;
    margin: 0;
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    align-items: center;
    -align: bottom;
    text-averticallign: center;
    overflow: hidden;
    position: relative;
    background: #4f46e5;
    color: #ffffff;
    border-color: #4f46e5;
    padding: 1rem 1.25rem;
    font-size: 1rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    border-radius: 6px;

    &:focus {
        box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #b1b3f8, 0 1px 2px 0 black;
        outline: 0 none;
        outline-offset: 0;
    }
}

.remove-picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
        transition-delay: all 0.8s ease-in-out;
        visibility: hidden;
    }

    &:hover {
        i {
            visibility: visible;
        }
    }
}
</style>
  